import {View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'
import {useNavigation} from '@react-navigation/native'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
  type NavigationProp,
} from '#/lib/routes/types'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {CircleX_Stroke2_Corner0_Rounded as CircleXIcon} from '#/components/icons/CircleX'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'TopupFail'>

export function TopupFailScreen({}: Props) {
  const t = useTheme()
  const {t: l} = useLingui()
  const navigation = useNavigation<NavigationProp>()

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            <Trans>Payment</Trans>
          </Layout.Header.TitleText>
        </Layout.Header.Content>
      </Layout.Header.Outer>
      <Layout.Content>
        <Layout.Center>
          <View
            style={[
              a.flex_1,
              a.align_center,
              a.justify_center,
              a.gap_2xl,
              a.px_2xl,
              a.py_4xl,
            ]}>
            <CircleXIcon size="xl" style={{color: t.palette.negative_500}} />
            <View style={[a.align_center, a.gap_md]}>
              <Text
                style={[a.text_2xl, a.font_bold, a.text_center, t.atoms.text]}>
                <Trans>Payment Failed</Trans>
              </Text>
              <Text
                style={[
                  a.text_md,
                  a.text_center,
                  t.atoms.text_contrast_medium,
                ]}>
                <Trans>
                  Something went wrong with your payment. Please try again or
                  contact support if the issue persists.
                </Trans>
              </Text>
            </View>
            <Button
              label={l`Try Again`}
              color="primary"
              size="large"
              onPress={() => navigation.navigate('Wallet')}>
              <ButtonText>
                <Trans>Try Again</Trans>
              </ButtonText>
            </Button>
          </View>
        </Layout.Center>
      </Layout.Content>
    </Layout.Screen>
  )
}
